<template>
  <div v-bind="$props">
    <div class="pb-2 text--primary image-input-label" :class="[$vuetify.theme.dark ? 'white-color' : 'dark-color']">
      {{ label }} <span v-if="required" class="required__icon">*</span>
    </div>
    <div class="image-input-block" :class="[$vuetify.theme.dark ? 'dark-input' : 'white-input']">
      <div class="d-flex align-center overflow-hidden">
        <div v-if="previewImageLoading === false">
          <v-btn :loading="previewImageLoading" class="btn-input-file" :color="buttonColor">
            <span v-if="contentUrl === ''">{{ $t("generic.buttons.select_image") }}</span>
            <span v-else>{{ $t("generic.buttons.change_image") }}</span>
            <input type="file" required accept="image/*" @change="uploadFile" />
          </v-btn>
        </div>
        <div class="ml-3" :class="{ 'dark-color': !$vuetify.theme.dark }">
          {{ imageName }}
        </div>
      </div>
      <div class="image-input-block__wrapper" v-if="contentUrl !== ''">
        <img class="author-image" :src="contentUrl" alt="img" />
      </div>

      <div v-if="contentUrl !== ''" class="exit-icon" @click="removeImage">
        <v-img v-if="$vuetify.theme.dark" src="@/assets/icons/x-white.svg"></v-img>
        <v-img v-else src="@/assets/icons/x-black.svg"></v-img>
      </div>
    </div>
    <span v-if="fileTypeError" class="fileType__error">
      {{ this.fileTypeError }}
    </span>
  </div>
</template>

<script>
  import Input from "@inulti/vuetify-admin/src/mixins/input";
  import { sendToServer } from "../../utility/mediaObjectUploadHelper";
  import { getFromServer } from "../../utility/fetchMediaObject";
  import definedAbility from "@/ability";

  export default {
    mixins: [Input],
    props: {
      label: {
        type: String,
        required: false,
        default: "Upload file",
      },
      itemId: {
        type: String,
        required: false,
        default: null,
      },
      onlyShowImg: {
        type: Boolean,
        required: false,
        default: false,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
      validFileTypes: {
        type: Array,
        default: () => {
          return [".svg", ".png", ".jpeg", ".jpg"];
        },
      },
    },
    emits: ["update:photo"],
    data() {
      return {
        previewImageLoading: true,
        contentUrl: "",
        imageRemoved: false,
        imageName: "",
        fileTypeError: "",
        ability: definedAbility(),
      };
    },
    beforeUpdate() {
      this.loadPreviewImage();
    },
    created() {
      this.previewImageLoading = true;
      this.loadPreviewImage();
    },
    computed: {
      buttonColor() {
        return this.contentUrl ? "success" : "primary";
      },
    },
    methods: {
      async loadPreviewImage() {
        if (!this.imageRemoved && this.itemId) {
          await getFromServer(this.itemId).then(res => {
            if (this.ability.can("upload", "media object to inulti server")) {
              this.contentUrl = process.env.VUE_APP_API + res["contentUrl"];
            } else {
              this.contentUrl = res["contentUrl"];
            }
            this.previewImageLoading = false;
          });
        } else {
          this.previewImageLoading = false;
        }
      },
      removeImage() {
        this.contentUrl = "";
        this.imageRemoved = true;
        this.imageName = "";
        this.$emit("update:photo", "");
      },
      uploadFile(fileToUpload) {
        const fileName = fileToUpload.target.files[0]?.name;
        const fileExtension = fileName.split(".")[fileName.split(".").length - 1];
        if (!this.validFileTypes.includes(`.${fileExtension}`)) {
          this.fileTypeError = `Wrong file format. Supported file formats: ${this.validFileTypes.join(", ")}`;
          this.removeImage();

          return;
        }
        this.fileTypeError = "";
        this.imageName = fileName;
        sendToServer(fileToUpload.target.files[0]).then(res => {
          if (this.ability.can("upload", "media object to inulti server")) {
            this.contentUrl = process.env.VUE_APP_API + res["contentUrl"];
          } else {
            this.contentUrl = res["contentUrl"];
          }
          this.$emit("update:photo", res);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .author-image {
    max-height: 38px;
    margin-right: 40px;
    max-width: 100%;
  }

  .image-input-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 12px;
    position: relative;

    &__wrapper {
      line-height: 0;
    }
  }

  .image-input-label {
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
  }

  .btn-input-file {
    position: relative;

    span {
      input {
        opacity: 0;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
      }
    }
  }

  .exit-icon {
    max-width: 12px;
    position: absolute;
    right: 12px;
    cursor: pointer;
  }

  .white-color {
    color: white;
  }

  .dark-color {
    color: #13274e;
  }

  .dark-input {
    background: #3a3657;
    border: 1px solid #4a4862;
  }

  .white-input {
    background: #fafafa;
    border: 1px solid #dad9dd;
  }

  .fileType__error {
    color: #ff4c51;
    margin-left: 15px;
  }
</style>
